import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Alert from 'flarum/common/components/Alert';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import LinkButton from 'flarum/common/components/LinkButton';
import { usingAppleWebview } from '../native/appleWebView';
import { getServiceWorkerRegistration } from '../registerServiceWorker';
import { supportsWebPush, pushConfigured } from './utils';
import { syncPushSubscription } from './subscription';
export default function addPushNotifications() {
  extend('flarum/forum/components/NotificationGrid', 'notificationMethods', function (items) {
    if (!pushConfigured()) return;
    items.add('push', {
      name: 'push',
      icon: 'fas fa-mobile',
      label: app.translator.trans('fof-pwa.forum.settings.push_header')
    });
  });
  extend('flarum/forum/components/SettingsPage', 'notificationsItems', function (items) {
    if (usingAppleWebview() || !pushConfigured()) return;
    if (!supportsWebPush()) {
      items.add('push-no-browser-support', m(Alert, {
        dismissible: false,
        controls: [m("a", {
          className: "Button Button--link",
          href: "https://developer.mozilla.org/en-US/docs/Web/API/Push_API",
          target: "_blank",
          rel: "noopener noreferrer"
        }, app.translator.trans('fof-pwa.forum.settings.pwa_notifications.no_browser_support_button'))]
      }, m(Icon, {
        name: "fas fa-exclamation-triangle"
      }), app.translator.trans('fof-pwa.forum.settings.pwa_notifications.no_browser_support')), 10);
      return;
    }
    if (Notification.permission === 'default') {
      items.add('push-optin-default', m(Alert, {
        dismissible: false,
        className: "pwa-setting-alert",
        controls: [m(Button, {
          className: "Button Button--link",
          onclick: async () => {
            try {
              const permission = await Notification.requestPermission();
              m.redraw();
              if (permission !== 'granted') return;
              const registration = await getServiceWorkerRegistration();
              if (!registration) return;
              await syncPushSubscription(registration);
            } catch (error) {
              console.error('[fof-pwa] Push subscription failed:', error);
            }
          }
        }, app.translator.trans('fof-pwa.forum.settings.pwa_notifications.access_default_button'))]
      }, m(Icon, {
        name: "fas fa-exclamation-circle"
      }), app.translator.trans('fof-pwa.forum.settings.pwa_notifications.access_default')), 10);
      return;
    }
    if (Notification.permission === 'denied') {
      items.add('push-optin-denied', m(Alert, {
        type: "error",
        dismissible: false,
        className: "pwa-setting-alert",
        controls: [m(LinkButton, {
          href: app.route('fof-pwa.notifications-help')
        }, app.translator.trans('fof-pwa.forum.settings.pwa_notifications.access_denied_button'))]
      }, m(Icon, {
        name: "fas fa-exclamation-triangle"
      }), app.translator.trans('fof-pwa.forum.settings.pwa_notifications.access_denied')), 10);
    }
  });
}
flarum.reg.add('fof-pwa', 'forum/push/addPushNotifications', addPushNotifications);